module.exports = __webpack_public_path__ + "static/img/home_qq_contact.54269bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/home_qq_contact.png
// module id = 339
// module chunks = 0